import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { addResourceHints } from "./lib/performance";

// Preconnect to critical origins (Sanity CDN, fonts)
addResourceHints();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
